/* Shared open/close + auto-wiring for .site-drawer panels.
 *
 *  - Open:  click anything with [data-drawer-open="<drawer-id>"]
 *  - Close: click anything with [data-drawer-close] inside the drawer,
 *           click the .site-drawer__overlay, or press Escape.
 *
 * On open, the drawer is hoisted to <body> so its z-index (99999) escapes
 * any ancestor stacking context (e.g. .site-main at z-index 500). A reflow
 * is forced before adding .is-open so the panel actually slides from the
 * right instead of appearing instantly.
 *
 * window.SiteDrawer.open(id) / .close(id) are also exposed for legacy
 * inline-onclick handlers.
 */
(function () {
  if (window.__siteDrawerInit) return;
  window.__siteDrawerInit = true;

  // iOS-safe body scroll lock. `body{overflow:hidden}` alone does NOT stop the
  // page scroller on iOS Safari, so a fixed drawer opened while the page is
  // scrolled ends up showing the wrong region (whitespace, content scrolled
  // off). Pin the body with position:fixed at its current offset, then restore
  // the scroll position on close. Guarded so stacked opens don't lose scrollY.
  var lockedScrollY = 0;
  var isLocked = false;
  function lockScroll() {
    if (isLocked) return;
    lockedScrollY = window.scrollY || window.pageYOffset || 0;
    var b = document.body;
    b.style.position = 'fixed';
    b.style.top = (-lockedScrollY) + 'px';
    b.style.left = '0';
    b.style.right = '0';
    b.style.width = '100%';
    b.style.overflow = 'hidden';
    isLocked = true;
  }
  function unlockScroll() {
    if (!isLocked) return;
    var b = document.body;
    b.style.position = '';
    b.style.top = '';
    b.style.left = '';
    b.style.right = '';
    b.style.width = '';
    b.style.overflow = '';
    isLocked = false;
    // theme.css sets `html { scroll-behavior: smooth }`, which turned this
    // restore into a visible scroll back down the page (ORG-295). Jump
    // instantly: switch smooth scrolling off for this one call. (The
    // behavior:'instant' option isn't honoured by older Safari.)
    var html = document.documentElement;
    var prev = html.style.scrollBehavior;
    html.style.scrollBehavior = 'auto';
    window.scrollTo(0, lockedScrollY);
    html.style.scrollBehavior = prev;
  }

  function open(id) {
    var d = typeof id === 'string' ? document.getElementById(id) : id;
    if (!d || !d.classList.contains('site-drawer')) return;
    if (d.parentNode !== document.body) document.body.appendChild(d);
    // Deferred-content hydration: any <template class="site-drawer__deferred">
    // inside the drawer is unwrapped on first open. Lets us defer heavy
    // HTML (vendor excerpts, etc.) until the user actually asks for it.
    var deferred = d.querySelectorAll('template.site-drawer__deferred');
    deferred.forEach(function (tpl) {
      var host = document.createElement('div');
      host.className = tpl.getAttribute('data-class') || 'site-drawer__deferred-host';
      host.innerHTML = tpl.innerHTML;
      tpl.parentNode.replaceChild(host, tpl);
    });
    // Force a reflow so the starting translateX(100%) is committed before
    // we add .is-open, which kicks off the slide transition.
    void d.offsetWidth;
    requestAnimationFrame(function () { d.classList.add('is-open'); });
    lockScroll();
  }

  function close(target) {
    var d;
    if (!target) {
      d = document.querySelector('.site-drawer.is-open');
    } else if (typeof target === 'string') {
      d = document.getElementById(target);
    } else if (target.closest) {
      d = target.closest('.site-drawer');
    }
    if (!d) return;
    d.classList.remove('is-open');
    // Only release the scroll lock once no site-drawer remains open.
    if (!document.querySelector('.site-drawer.is-open')) unlockScroll();
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      var id = opener.getAttribute('data-drawer-open');
      if (id) {
        e.preventDefault();
        open(id);
        return;
      }
    }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer) {
      e.preventDefault();
      close(closer);
      return;
    }
    if (e.target.classList && e.target.classList.contains('site-drawer__overlay')) {
      close(e.target);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });

  window.SiteDrawer = { open: open, close: close };
})();
